import { Column, Entity, Index, OneToMany } from 'typeorm';
import { ApiConfigurationParameterEntity } from './api-configuration-parameter.entity';
import { BaseEntity } from './base.entity';
import { ParameterOptionEntity } from './parameter-option.entity';

@Index('_alias-unique', ['alias'], { unique: true })
@Entity('_parameter')
export class ParameterEntity extends BaseEntity {
	@Column('varchar', { name: '_label', length: 255 })
	public label!: string;

	@Column('varchar', { name: '_alias', unique: true, length: 255 })
	public alias!: string;

	@Column('tinyint', { name: '_required', width: 1, default: () => "'0'" })
	public required!: boolean;

	@Column('varchar', { name: '_type', length: 32 })
	public type!: string;

	@OneToMany(
		() => ApiConfigurationParameterEntity,
		(apiConfigurationParameter) => apiConfigurationParameter.fkParameter,
		{},
	)
	public apiConfigurationParameters!: Array<ApiConfigurationParameterEntity>;

	@OneToMany(
		() => ParameterOptionEntity,
		(parameterOption) => parameterOption.fkParameter,
		{},
	)
	public parameterOptions!: Array<ParameterOptionEntity>;
}
